export const addSystemMessage = (formattedMessages: any[], systemMessage: string, model: string) => {
    let formattedMessage: any = {
        role: "system",
        content: []
    };

    const formattedSystemMessage = {type: 'text', text: systemMessage};
    if (model.includes("Claude")) formattedMessage.cache_control = { type: "ephemeral" };
    formattedMessage.content.push(formattedSystemMessage);

    formattedMessages.unshift(formattedMessage);
}
